import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { SalesloftCadenceStep } from "app/pages/sales-intelligence/modules/salesloft/types/salesloft.types";

type CadenceStepsTooltipContentProps = {
    steps: SalesloftCadenceStep[];
    lastDay: number | null;
};

const formatStepType = (type: string | null): string => (type ? type.charAt(0).toUpperCase() + type.slice(1) : "");

const getStepLabelParts = (step: SalesloftCadenceStep, index: number) => ({
    order: index + 1,
    number: step.stepNumber ?? String(index + 1),
    type: formatStepType(step.type) || step.displayName || "",
});

export const CadenceStepsTooltipContent = ({ steps, lastDay }: CadenceStepsTooltipContentProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            flexDirection="column"
            gap="4px"
            maxWidth="280px"
            data-automation="playbook-cadence-steps-tooltip"
        >
            <Text
                fontVariant="listItem1"
                color={colorsPalettes.carbon["0"]}
            >
                {translate("si.playbooks.cadence.steps.tooltip.title")}
            </Text>
            {lastDay !== null ? (
                <Text
                    fontVariant="tooltip"
                    color={colorsPalettes.carbon["200"]}
                    padding="0 0 4px 0"
                >
                    {translate("si.playbooks.cadence.steps.tooltip.days", { count: lastDay })}
                </Text>
            ) : null}
            {steps.map((step, index) => (
                <Text
                    key={step.id}
                    fontVariant="tooltip"
                    color={colorsPalettes.carbon["0"]}
                >
                    {translate("si.playbooks.cadence.steps.step_label", getStepLabelParts(step, index))}
                </Text>
            ))}
        </Flex>
    );
};
